var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 21.5,
    r: 13.5,
    fill: "#2F49D1",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 21.5,
    r: 9.5,
    fill: "#2F49D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 16.3333C14.1889 16.3333 13.9505 16.4255 13.7746 16.5896C13.5988 16.7537 13.5 16.9763 13.5 17.2083C13.5 17.4404 13.5988 17.663 13.7746 17.8271C13.9505 17.9912 14.1889 18.0833 14.4375 18.0833C14.6862 18.0833 14.9246 17.9912 15.1005 17.8271C15.2763 17.663 15.375 17.4404 15.375 17.2083C15.375 16.9763 15.2763 16.7537 15.1005 16.5896C14.9246 16.4255 14.6862 16.3333 14.4375 16.3333ZM14.2125 19.1158C13.4688 19.1742 11.4375 20.685 11.4375 20.685C11.3125 20.7725 11.35 20.7667 11.45 20.93C11.55 21.0875 11.5375 21.0992 11.6563 21.0233C11.7813 20.9475 11.9875 20.825 12.3313 20.6267C13.6563 19.8333 12.5438 21.665 11.975 24.7508C11.75 26.2792 13.225 25.4917 13.6063 25.2583C13.9813 25.0308 14.9875 24.3833 15.0875 24.3192C15.225 24.2317 15.125 24.1617 15.0188 24.0158C14.9438 23.9167 14.8688 23.9867 14.8688 23.9867C14.4625 24.2375 13.7188 24.7625 13.6188 24.43C13.5 24.0975 14.2625 21.8167 14.6813 20.2475C14.75 19.8742 14.9375 19.0575 14.2125 19.1158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.40abb6f4.svg";
export { ForwardRef as ReactComponent };